module.exports = __webpack_public_path__ + "src/assets/img/page6/6b8ad2962d3602be261b9212ba799340.png";